export function bringIntoBookPath(storyId) {
  return storyId ? `/bring-into-book/${storyId}` : '/bring-into-book';
}

export function bringIntoBookBookId({ pathname = '', currentStory, currentSession } = {}) {
  const onBring = (pathname || '').match(/^\/bring-into-book\/([^/]+)/);
  if (onBring?.[1]) return onBring[1];

  const notes = (pathname || '').match(/^\/projects\/[^/]+\/stories\/([^/]+)\/notes\/?$/);
  if (notes?.[1]) return notes[1];

  const onTasks = (pathname || '').match(/^\/(?:tasks|path)\/([^/]+)/);
  if (onTasks?.[1]) return onTasks[1];

  if ((pathname || '').startsWith('/chat/') && currentSession?.story_id) {
    return currentSession.story_id;
  }

  return currentStory?.id || currentSession?.story_id || null;
}
